<template>
<div class="relative my-20 md:mt-36 md:mb-32 w-full items-center flex justify-center">
    <div class="borderRadius h-[382px] flex w-4/5 sm:w-[65%] justify-center bg-mainColor relative md:w-full xl:h-44 md:h-64">
    </div>
    <div class="blue-rectangle pt-7 px-6 pb-6 flex md:p-12 lg:py-14 lg:px-[72px] items-center justify-center w-full absolute sm:w-11/12 lg:w-[95%]">
        <div v-if="!isSuccess" class="flex flex-col w-full">
            <div v-if="page === 'blog-article'">
                <p class="text-white leading-[32px] md:leading-[46px] text-center font-semibold text-2xl md:text-40">
                    <span class="subscribe-gradient">
                        Subscribe
                    </span> via email and know it all first!
                </p>
                <div class="flex justify-center flex-wrap xl:flex-nowrap gap-x-6 lg:mb-5 mt-5 sm:mt-8 lg:mt-10">
                    <div class="relative w-full mb-5 md:mb-0 md:w-[47%] xl:w-2/5">
                        <input v-model="form.name" type="text" id="name" class="block w-full px-2.5 pb-2.5 pt-5 outline-none focus:border-white focus:border text-white appearance-none bg-transparent rounded-[14px] focus:outline-none focus:ring-0 peer" placeholder=" " />
                        <label for="name" class="absolute text-sm text-gray duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-inputLabel peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Full
                            Name</label>
                    </div>
                    <div class="relative w-full md:w-[47%] xl:w-2/5">
                        <input v-model="form.email" type="email" id="email" class="block w-full px-2.5 pb-2.5 pt-5 outline-none focus:border-white focus:border text-white appearance-none bg-transparent rounded-[14px] focus:outline-none focus:ring-0 peer" placeholder=" " />
                        <label for="email" class="absolute text-sm text-gray duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-inputLabel peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Email
                            *</label>
                        <span v-if="emailValidationError" class="text-gray-200 m-2">E-mail is invalid</span>
                    </div>
                    <button @click.prevent="subscribe" class="btn-primary mt-6 sm:mt-9 xl:mt-0 w-full sm:w-2/5 xl:w-1/5 text-sm transition duration-200">
                        SUBSCRIBE
                    </button>
                </div>
            </div>
            <div v-if="page === 'blog'">
                <p class="text-white leading-[32px] sm:leading-[42px] text-center sm:text-left font-semibold text-2xl sm:text-34">
                    Let's learn together technology trends, tips, and tricks.
                </p>
                <div class="flex flex-col gap-x-6 mb-5 mt-5 sm:mt-8 lg:mt-10">
                    <div class="flex flex-col sm:flex-row">
                        <div class="flex flex-col sm:w-4/5  ">
                            <div class="relative w-full ">
                                <input v-model="form.email" type="text" id="email" class="block w-full px-2.5 pb-2.5 pt-5 appearance-none focus:border-white focus:border text-white bg-transparent rounded-[14px] focus:outline-none focus:ring-0 peer" placeholder=" " />
                                <label for="email" class="absolute text-sm text-gray duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-inputLabel peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4">Email</label>
                                <span v-if="emailValidationError" class="text-gray-200 m-2">E-mail is invalid</span>
                            </div>
                            <div class="flex gap-x-9 max-sm:mb-5 mt-5">
                                <div class="flex">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M13.7 7.3C13.3 6.9 12.7 6.9 12.3 7.3L9 10.6L7.7 9.3C7.3 8.9 6.7 8.9 6.3 9.3C5.9 9.7 5.9 10.3 6.3 10.7L8.3 12.7C8.5 12.9 8.8 13 9 13C9.2 13 9.5 12.9 9.7 12.7L13.7 8.7C14.1 8.3 14.1 7.7 13.7 7.3Z" fill="#FD833F" />
                                    </svg>
                                    <p class="text-xs sm:text-[14px] font-light text-grayInContainer">No
                                        spam
                                    </p>
                                </div>
                                <div class="flex">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M13.7 7.3C13.3 6.9 12.7 6.9 12.3 7.3L9 10.6L7.7 9.3C7.3 8.9 6.7 8.9 6.3 9.3C5.9 9.7 5.9 10.3 6.3 10.7L8.3 12.7C8.5 12.9 8.8 13 9 13C9.2 13 9.5 12.9 9.7 12.7L13.7 8.7C14.1 8.3 14.1 7.7 13.7 7.3Z" fill="#FD833F" />
                                    </svg>
                                    <p class="text-xs sm:text-[14px] font-light text-grayInContainer">100%
                                        Useful
                                        content, always</p>
                                </div>
                            </div>
                        </div>
                        <button @click.prevent="subscribe" class="btn-primary w-full sm:ml-5 sm:w-36 text-sm transition duration-200">
                            SUBSCRIBE
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="flex w-full items-center flex-col">
            <div class="flex  items-center  ">
                <div class="mb-6 mr-8">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-20 h-20 " viewBox="0 0 120 120" fill="none">
                        <rect width="120" height="120" rx="60" fill="white" fill-opacity="0.06" />
                        <path d="M74.8 49.2C73.2 47.6 70.8 47.6 69.2 49.2L56 62.4L50.8 57.2C49.2 55.6 46.8 55.6 45.2 57.2C43.6 58.8 43.6 61.2 45.2 62.8L53.2 70.8C54 71.6 55.2 72 56 72C56.8 72 58 71.6 58.8 70.8L74.8 54.8C76.4 53.2 76.4 50.8 74.8 49.2Z" fill="#FD833F" />
                    </svg>
                </div>
                <h1 class="font-trap text-white text-center leading-9 sm:leading-12 text-[24px] mb-4 lg:mb-2 sm:text-34 font-semibold">
                    You are subscribed!
                </h1>
            </div>
            <div class="flex justify-center lg:justify-end  w-full">
                <button @click="hideSuccessMessage" class="btn-primary w-full sm:w-[168px] text-sm uppercase transition duration-200">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios";

export default {
    name: "Subscribe",
    data() {
        return {
            form: {
                name: "",
                email: ""
            },
            emailValidationError: false,
            isSuccess: false,
            isLoading: false
        }
    },
    props: {
        page: String,
    },
    methods: {
        subscribe(event) {
            const formData = new FormData();
            formData.append('name', this.form.name);
            formData.append('email', this.form.email);

            let emailRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            this.emailValidationError = !emailRe.test(String(this.form.email).toLowerCase());

            if (!this.emailValidationError) {
                this.isLoading = true;
                axios
                    .post("/api/subscribe", formData)
                    .then((response) => {
                        this.isLoading = false;
                        this.form.name = this.form.email = '';
                        this.showSuccessMessage();
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    });
            }
        },
        showSuccessMessage() {
            this.isSuccess = true;
        },
        hideSuccessMessage() {
            this.isSuccess = false;
        }
    }
};
</script>
